<script>
	import {supabase} from "./supabaseClient"
	
	export let view = null;
	let element = 'Bookmark or Excerpt';
	if (view) {
		element = view == 'bookmarks' ? 'bookmark' : 'excerpt'; 
	} 
	let name = '';
	try {
		name = supabase.auth.user()?.email?.split('@')[0];
	} catch (error) {
		console.warn(error);
	}
	
	let nameText = name ? ', ' + name : '';
	let headerText = [
		`Let's get started`,
		`Welcome`
	]

	function getRandomEntry(arr) {
		return arr[Math.floor(Math.random() * arr.length)];
	}

	let bodyText = [
		`Not the fanciest website in the world, but hey, it's better than trying to remember every ${element}.`,
		`Bring your own ${element}s. Jokes and bugs are on the house.`,
		`Here is our humble ${element} storage, where we promise not to judge your questionable choices.`,
		`Here is our humble abode, where your ${element}s will never be lost in the black hole of the internet. Unless you forget your email password, that is.`	]
</script>

<div id="welcome-container">
	<h1>
		{getRandomEntry(headerText)}<span class="name">{nameText}</span>!
	</h1>
	<div class="body-text">
		{getRandomEntry(bodyText)}
	</div>
	<div id="footnote">
		Click the "➕" icon to add your first {element} now. 
	</div>
</div>

<style>
	#welcome-container {
		background-color: rgb(54, 54, 54);
		margin: 1em;
		padding: 2em;
		border-radius: 5px;
		min-width: 15em;
	}
	#footnote {
		margin: 1em auto;
		padding: 1em;
		background-color: rgb(38, 38, 38);
		border-radius: 5px;
		font-size: 0.9em;
	}
	.name {
		font-style: italic;
	}
</style>